import React, {Component} from 'react';
import { Alert } from 'reactstrap';
import {withRouter} from 'react-router-dom';
import auth0Client from '../Auth';
import axios from 'axios';
import {SERVER_URL}  from '../Constants';
class AddEditLocation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      disabled: false,
      locationName: '',
      description: '',
      venue: {id:1},
      active: true,
      showAlert: false,
      error: '',
      locationId: -1,
    };
  }

  async componentDidMount() {
    

    const locations = (await axios.get(SERVER_URL +' /location/' + this.state.locationId,{
        headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}` }
      })).data;
    this.setState({
        locations,
    });
  }


  updateDescription(value) {
    this.setState({
      description: value,
    });
  }

  updatelocationName(value) {
    this.setState({
        locationName: value,
    });
  }
  updateActive(value) {
    this.setState({
        active: value,
    });
  }
  handleDismiss=()=> {
    this.setState({ showAlert: false });
  }
  renderAlert=()=>{
        if (this.state.showAlert){
            
            return (
                <Alert color='danger' onDismiss={this.handleDismiss}>
                <h4>Oh snap! You got an error!</h4>
                <p>{this.state.error.response.data}</p>
              </Alert>
            );
        }

  }

  async submit() {
    this.setState({
      disabled: true,
    });

    await axios.post(SERVER_URL +'/location/' + this.state.venue.id, {
        locationName: this.state.locationName,
        description: this.state.description,
        active:this.state.active,
        id:'',

    }, {
      headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}` }
    })
    .then((res)=>{
        this.props.history.push('/locations');
    })
    .catch ((e)=>{
        
        this.setState({
            showAlert:true,
            disabled: false,
            error:e,

        })
      
    })

    
  }

  render() {
    return (
      <div className="container">
      
        <div className="row">
          <div className="col-12">
            <div className="card border-primary">
              <div className="card-header">New Location</div>
              <div className="card-body text-left">
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Location (i.e. Admin Office, Main Office Lost and Found, Gym Office):</label>
                  <input
                    disabled={this.state.disabled}
                    type="text"
                    onBlur={(e) => {this.updatelocationName(e.target.value)}}
                    className="form-control"
                    placeholder="Give your location a name."
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Description:</label>
                  <input
                    disabled={this.state.disabled}
                    type="text"
                    onBlur={(e) => {this.updateDescription(e.target.value)}}
                    className="form-control"
                    placeholder="Please provide a description for the location."
                  />
                </div>

                <div className="form-check">
                  
                  <input
                    disabled={this.state.disabled}
                    type="checkbox"
                    onBlur={(e) => {this.updateActive(e.target.value)}}
                    className="form-check-input"
                    placeholder=""
                    checked = {this.state.active}
                  />
                  <label htmlFor="exampleInputEmail1">Active : Check to make active.  Uncheck to deactivate adding items to this location. </label>
                  

                </div>

                <button
                  disabled={this.state.disabled}
                  className="btn btn-primary"
                  onClick={() => {this.submit()}}>
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.renderAlert()}
        
      
      </div>
    )
  }
}

export default withRouter(AddEditLocation);